const MEDIA_UPLOAD_V1_PATH = '/api/v1/media-upload';

export const VIDEO_UPLOAD_PATH = `${MEDIA_UPLOAD_V1_PATH}/video-upload`;
export const VIDEO_UPLOAD_DETAIL_PATH = `${VIDEO_UPLOAD_PATH}/:videoUploadId`;
export const VIDEO_UPLOAD_SEARCH_PATH = `${VIDEO_UPLOAD_PATH}/search`;

const EXTERNAL_MEDIA_PATH = `${MEDIA_UPLOAD_V1_PATH}/external-media`;
export const YOUTUBE_INFO_PATH = `${EXTERNAL_MEDIA_PATH}/youtube-info`;
export const MEDIA_CONTENT_INFO_PATH = `${EXTERNAL_MEDIA_PATH}/media-content-info`;

export const TEXT_BLOB_PATH = `${MEDIA_UPLOAD_V1_PATH}/text-blob`;
export const TEXT_BLOB_DETAIL_PATH = `${TEXT_BLOB_PATH}/:textBlobId`;

export const GIF_CONVERTER_PATH = `${MEDIA_UPLOAD_V1_PATH}/gif-converter`;

export const PARSE_EXTERNAL_MEDIA_PATH = `${EXTERNAL_MEDIA_PATH}/parse-content`;

export const DIRECT_UPLOAD_PATH = `${MEDIA_UPLOAD_V1_PATH}/direct-upload`;

export const MULTIPART_DIRECT_UPLOAD_PATH = `${DIRECT_UPLOAD_PATH}/multipart`;
export const MULTIPART_DIRECT_UPLOAD_INIT_PATH = `${MULTIPART_DIRECT_UPLOAD_PATH}/init`;
export const MULTIPART_DIRECT_UPLOAD_PRESIGN_PARTS_PATH = `${MULTIPART_DIRECT_UPLOAD_PATH}/presign-parts`;
export const MULTIPART_DIRECT_UPLOAD_COMPLETE_PATH = `${MULTIPART_DIRECT_UPLOAD_PATH}/complete`;
export const MULTIPART_DIRECT_UPLOAD_ABORT_PATH = `${MULTIPART_DIRECT_UPLOAD_PATH}/abort`;

export const MEDIA_SEGMENT_PATH = `${MEDIA_UPLOAD_V1_PATH}/media-segment`;
export const MEDIA_SEGMENT_DETAIL_BY_ID_PATH = `${MEDIA_SEGMENT_PATH}/:uuid`;
export const MEDIA_SEGMENT_DETAIL_BY_REVISION_ID_PATH = `${MEDIA_SEGMENT_DETAIL_BY_ID_PATH}/revision/:revisionId`;

export const VIDEO_LAYOUT_TIMELINE_PATH = `${MEDIA_UPLOAD_V1_PATH}/video-layout-timeline`;
export const VIDEO_LAYOUT_TIMELINE_DETAIL_PATH = `${VIDEO_LAYOUT_TIMELINE_PATH}/:uuid`;
export const VIDEO_LAYOUT_TIMELINE_REVISION_DETAIL_PATH = `${VIDEO_LAYOUT_TIMELINE_DETAIL_PATH}/revision/:revisionId`;
export const VIDEO_LAYOUT_TIMELINE_REVISION_SEGMENT_PATH = `${VIDEO_LAYOUT_TIMELINE_REVISION_DETAIL_PATH}/segment/:segmentId`;

export const ENTIRE_VIDEO_PATH = `${MEDIA_UPLOAD_V1_PATH}/entire-video`;
export const ENTIRE_VIDEO_DETAIL_PATH = `${ENTIRE_VIDEO_PATH}/:entireVideoId`;
export const ENTIRE_VIDEO_INSTANCE_PATH = `${ENTIRE_VIDEO_PATH}/instance`;
export const ENTIRE_VIDEO_INSTANCE_DETAIL_PATH = `${ENTIRE_VIDEO_INSTANCE_PATH}/:entireVideoInstanceId`;
export const ENTIRE_VIDEO_SEARCH_PATH = `${ENTIRE_VIDEO_PATH}/search`;
